export default __webpack_public_path__ + "supermarket261d50.png";